module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-grey-2-55c3e1074dc1d08e0b7cfd92f715592b.webp";